"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scroll;
exports.scrollToId = void 0;
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var _browser = require("./browser");
// The duration of the scroll (in milliseconds)
var SCROLL_DURATION = 128;

/**
 * The curve function describes the progress of an
 * animation given a normalised time between 0 and 1.
 * There are a tonne of different easing curves that
 * we could use, but a simple quadratic curve seems
 * to be ideal for scroll animations.
 *
 * SEE: https://github.com/d3/d3-ease/tree/master/src
 *
 * @param {Number} t - the normalised current time (0 - 1)
 *
 * @returns {Number} p - the normalised progress (0 - 1)
 */
function curve(t) {
  return t * t;
}

/**
 * Smoothly scroll the page to the the desired element
 * (generally some specific block of content) using the
 * easing curve above.
 *
 * @param {Object} the global window opject
 * @param {String} the id of the element to scroll into view
 * @param {Number} An offset (in pixels) to apply to the scroll
 */
function scroll(_window, id) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (!_window) return undefined;
  var e = _window.document.getElementById(id);
  if (!e) return undefined;
  var _requestAnimationFrame = (0, _browser.getRaf)(_window);
  var scrollYOrigin = _window.scrollY;
  var scrollYDestination = e.getBoundingClientRect().top + scrollYOrigin + offset;
  var scrollYDifference = scrollYDestination - scrollYOrigin;
  var startTime = (0, _now.default)();
  return function iterate() {
    _requestAnimationFrame(() => {
      var _ = ((0, _now.default)() - startTime) / SCROLL_DURATION;
      if (_ <= 1) {
        _window.scrollTo(0, scrollYOrigin + curve(_) * scrollYDifference);
        iterate();
        return;
      }
      _window.scrollTo(0, scrollYDestination);
    });
  }();
}
var scrollToId = function (_window) {
  var {
    getOffset
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return e => {
    e.preventDefault();
    e.stopPropagation();
    var [, id] = e.currentTarget.href.match(/#([^ ]+)$/) || [];
    var offset = getOffset ? getOffset(e) : 0;
    if (id) scroll(_window, id, offset);
  };
};
exports.scrollToId = scrollToId;